'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Polling function
 *
 * @param {function} fn The condition to poll
 * @param {integer} timeout Allowed execution time
 * @param {integer} interval Delay before next execution
 *
 */

var poll = function poll(fn, timeout, interval) {
    var endTime = Number(new Date()) + (timeout || 2000);
    interval = interval || 100;

    var checkCondition = function checkCondition(resolve, reject) {
        // If the condition is met, we're done!
        var result = fn();
        if (result) {
            resolve(result);
        }
        // If the condition isn't met but the timeout hasn't elapsed, go again
        else if (Number(new Date()) < endTime) {
                setTimeout(checkCondition, interval, resolve, reject);
            }
            // Didn't match and too much time, reject!
            else {
                    reject(new Error('timed out for ' + fn + ': ' + arguments));
                }
    };

    return new Promise(checkCondition);
};

exports.default = poll;